import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Tag, Radio, Typography, Space, Divider } from "antd";

const { Title, Text } = Typography;
const PRIMARY = "#4f57f6";

const Type = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/addservers/type");
  }, []);

  const cards = [
    {
      title: "Cost-Optimized",
      tag: "Limited availability",
      description:
        "Cost-efficient on older hardware generations, with limited availability. Ideal for variable workloads that can handle changing CPU performance. Optimized for low CPU usage.",
      badges: [
        "Cost effective",
        "Low CPU usage",
        "Medium traffic applications",
      ],
      architecture: ["x86 (Intel®/AMD)", "Arm64 (Ampere®)"],
    },
    {
      title: "Regular Performance",
      description:
        "Higher CPU performance based on newer hardware generations. Optimized for low to medium CPU usage.",
      badges: [
        "Best price/performance",
        "Low to medium CPU usage",
        "Medium traffic applications",
      ],
      architecture: ["x86 (AMD)"],
    },
    {
      title: "General Purpose",
      description:
        "Dedicated vCPUs with consistent and predictable performance. Best for production workloads.",
      badges: [
        "Predictable performance",
        "Critical production",
        "Sustained high CPU usage",
        "High traffic applications",
      ],
      architecture: ["x86 (AMD)"],
    },
  ];

  return (
    <div
      style={{
        padding: "40px 60px",
        background: "#f9fafb",
        minHeight: "100vh",
      }}
    >
      <div style={{ maxWidth: 980, margin: "0 auto" }}>
        {/* Page Title */}
        <Title level={2} style={{ color: "#111827", marginBottom: 20 }}>
          Create a server
        </Title>

        {/* Section Title */}
        <Space align="center" style={{ marginBottom: 20 }}>
          <Text style={{  fontSize: 20, fontWeight: 600 }}>
            Type
          </Text>
        </Space>

        {/* Categories */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col>
            <div
              style={{
                background: "#eef2ff",
                padding: "10px 22px",
                borderRadius: 10,
                color: PRIMARY,
                fontWeight: 500,
                width: 650,
              }}
            >
              Shared Resources
            </div>
          </Col>

          <Col>
            <div
              style={{
                background: "#eef2ff",
                padding: "10px 22px",
                borderRadius: 10,
                color: PRIMARY,
                fontWeight: 500,
                width: 300,
              }}
            >
              Dedicated Resources
            </div>
          </Col>
        </Row>

        {/* Cards */}
        <Row gutter={[20, 20]}>
          {cards.map((card, index) => (
            <Col xs={24} md={12} lg={8} key={index}>
              <Card
                hoverable
                style={{
                  borderRadius: 14,
                  border: `1px solid ${PRIMARY}`,
                  minHeight: "100%",
                }}
              >
                <div style={{ minHeight: 260 }}>
                  <Title level={4} style={{ marginBottom: 10 }}>
                    {card.title}{" "}
                    {card.tag && (
                      <Tag
                        style={{
                          background: "#eef2ff",
                          color: PRIMARY,
                          borderRadius: 6,
                        }}
                      >
                        {card.tag}
                      </Tag>
                    )}
                  </Title>

                  <Text style={{ color: "#4b5563", fontSize: 14 }}>
                    {card.description}
                  </Text>

                  <div style={{ marginTop: 16 }}>
                    <Space wrap>
                      {card.badges.map((b, i) => (
                        <Tag
                          key={i}
                          style={{
                            background: "#f1f5f9",
                            color: PRIMARY,
                            borderRadius: 8,
                            padding: "5px 10px",
                          }}
                        >
                          {b}
                        </Tag>
                      ))}
                    </Space>
                  </div>
                </div>

                <Divider />

                <Text style={{ fontSize: 12, color: "#6b7280" }}>
                  ARCHITECTURE
                </Text>

                <Radio.Group style={{ marginTop: 8 }}>
                  <Space direction="vertical">
                    {card.architecture.map((opt, i) => (
                      <Radio key={i} value={opt}>
                        {opt}
                      </Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default Type;
